import { render, staticRenderFns } from "./theme1.vue?vue&type=template&id=b4952b3e&"
import script from "./theme1.vue?vue&type=script&lang=ts&"
export * from "./theme1.vue?vue&type=script&lang=ts&"
import style0 from "./theme1.vue?vue&type=style&index=0&id=b4952b3e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports